import React from 'react';

function RenderConsultation({ data, id, isMigratioin }) {
  return (
    <div className="smart-tag-sec content-line-break content-line-break">
      <div className="smart-tag-bdy">
        <div className="smart-tag-bdy-rw width100" id={'sectionVal_' + id}>
          {data?.consultationData?.map((item, i) => (
            <div key={i} className="smart-tag-bdy-rw width100 recrd-nt-rw">
              {item[2]?.length > 0 && (
                <div className="cntnt-blk-hdng qfrst-sec-lbl qrecrd-nt-prnt-hdng">{isMigratioin ?'':item[1]}</div>
              )}
              {item[2] &&
                item[2]?.map((subItem, j) => (
                  <div key={j} className="smart-tag-bdy-rw">
                    <span className="frst-sec-lbl">{subItem?.label}:</span>
					<span className="frst-sec-val sec-colr"
					  dangerouslySetInnerHTML={{
						__html: subItem?.content ? subItem?.content : '',
					  }}
					/>
                  </div>
                ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default RenderConsultation;
